<button type="button" @click="backToTop" class="btn btn-default" :title="$t('vm.components.button-to-top.label')">
    <svg width="1em" class="svg-middle" viewBox="0 0 448 512" aria-hidden="true" focusable="false">
        <use xlink:href="@Assets/svg/symbol-defs.svg#arrow-alt-up"/>
    </svg>
    <span class="sr-only">{{ $t('vm.components.button-to-top.label') }}</span>
</button>
